export default {
  state:{
     isCollapse: true
  },
  mutations:{
     setCollapse(state, value) {
       state.isCollapse = value
     },
  }
}